
import React, {Component} from 'react'
import AudioPlayer from '../../../common/helpers/AudioPlayer'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import WithAjax from '../../../common/helpers/WithAjax'
import WithNotify from '../../../common/helpers/WithNotify'
import ProtectedElement from '../../../common/helpers/ProtectedElement'
import {clearSkillVendorCurrentProfile} from '../../../../actions/pages/skillvendor-page'
import {
    PROFILE_STATUS_PENDINGQUALIFICATION,
    PROFILE_STATUS_QUALIFIED,
    PROFILE_STATUS_REJECTED,
    PERMISSION_TALENTS_PROFILE_DIRECTOR_WRITE,
    PERMISSION_TALENTS_PROFILE_TRANSLATOR_WRITE,
    PERMISSION_TALENTS_PROFILE_VOICEACTOR_WRITE,
    PERMISSION_TALENTS_PROFILE_SINGER_WRITE,
    PERMISSION_TALENTS_PROFILE_ADAPTOR_WRITE,
    PERMISSION_TALENTS_PROFILE_LYRICIST_WRITE,
    PERMISSION_TALENTS_PROFILE_EDITOR_WRITE,
    PERMISSION_TALENTS_PROFILE_SOUNDENGINEER_WRITE,
    PERMISSION_TALENTS_PROFILE_BOOKER_WRITE
  } from '../../../../constants'

class RemoteSamplesBox extends Component {
  constructor(){
    super();
    this.data = '';
    this.removeData = '';

    this.removeSample = this.removeSample.bind(this)
    this.handleAdd = this.handleAdd.bind(this)
    this.onFileChange = this.onFileChange.bind(this)
  }

  getPermissionsToCheck(profileData) {
    switch (profileData.ProfileType) {
      case 'Director':
        return PERMISSION_TALENTS_PROFILE_DIRECTOR_WRITE;
      case 'Translator':
        return PERMISSION_TALENTS_PROFILE_TRANSLATOR_WRITE;
      case 'VoiceActor':
        return PERMISSION_TALENTS_PROFILE_VOICEACTOR_WRITE;
      case 'Singer':
        return PERMISSION_TALENTS_PROFILE_SINGER_WRITE;
      case 'Adaptor':
        return PERMISSION_TALENTS_PROFILE_ADAPTOR_WRITE;
      case 'Lyricist':
        return PERMISSION_TALENTS_PROFILE_LYRICIST_WRITE;
      case 'Editor':
        return PERMISSION_TALENTS_PROFILE_EDITOR_WRITE;
      case 'SoundEngineer':
        return PERMISSION_TALENTS_PROFILE_SOUNDENGINEER_WRITE;
      case 'Booker':
        return PERMISSION_TALENTS_PROFILE_BOOKER_WRITE;
      default:
        return null;
    }
  }

  onFileChange(e, field) {
    let value = e.target.files[0];
    var extensions = ['mp3', 'm4a', 'mp4'];
    if (value && value.size > 5242880) {
      alert('Maximum file size is 5MB.');
      e.target.value = null;
      return;
    }

    if(extensions.indexOf(value.name.split('.').pop()) === -1){
      alert('This extension of file is wrong.');
      e.target.value = null;
      return;
    }

    this.data = {"SampleFile": value};

  }

  handleAdd(event) {
    event.preventDefault();

    let formData = this.convertToFormData(this.data);
    var profileType = (this.props.profileData.ProfileType).toLowerCase();
    let url = 'skillvendors/' + this.props.skillVendorId + '/profiles/' + profileType +'/remoterecordingsamples';

    this.props.ajax.post(url, formData, null, () => {
      this.props.clearSkillVendorCurrentProfile();
    })
  }

  convertToFormData(data){
    var formData = new FormData();
    formData.append("SampleFile", data['SampleFile']);

    return formData;
}

  removeSample(fileName){
    if(window.confirm("Remove this file?")){
      this.removeData = {"removeData": fileName};
      let removeData = this.convertToFormData(this.removeData);
      var profileType = (this.props.profileData.ProfileType).toLowerCase();
      let url = 'skillvendors/' + this.props.skillVendorId + '/profiles/' + profileType +'/remoterecordingsamples?fileName=' + fileName;

      this.props.ajax.delete(url,removeData,  null, () => {
        this.props.clearSkillVendorCurrentProfile();
      })
  }

  }

  render() {
    const config = {}, tracks = {};

    let styles =
      /* SVG file with control buttons */
        + '.mejs__overlay-button {background-image: url("/assets/images/mejs-controls.svg") !important;}'
        + '.mejs__overlay-loading-bg-img {background-image: url("/assets/images/mejs-controls.svg") !important;}'
        + '.mejs__button > button {background-image: url("/assets/images/mejs-controls.svg") !important;}'
      /*MediaElementJs customizations */
        + '.mejs__container, .mejs__controls:not([style*="display: none"]) {background: transparent;}'
      /*Texts*/
        + '.mejs__time {color: #ff5402;}'
      /*Time scale*/
        + '.mejs__time-rail .mejs__time-total {background: #e0e0e0;}'
        + '.mejs__time-rail .mejs__time-buffering {background: #ff5402;}'
        + '.mejs__time-rail .mejs__time-loaded {background: #e0e0e0;}'
        + '.mejs__time-rail .mejs__time-current {background: #ff5402;}'
      /*Time scale circle handle*/
        + '.mejs__time-handle-content {border: 4px solid #b23a01;}'
        + '.mejs__time-current, .mejs__time-handle-content {background: #ff651b;}'
      /*Volume control*/
        + '.mejs__horizontal-volume-current {background: #ff5402;}'
        + '.mejs__horizontal-volume-total {background: #e0e0e0;}';

    if(this.props.profileData !== undefined){
       var permissionToCheck = this.getPermissionsToCheck(this.props.profileData);
    }

    return (
      <React.Fragment>
        <div className={`widget ${ this.props.classColumn }`}>
          <div className="title">Remote recording samples</div>
          <div className="row">
            <style>
            {styles}
            </style>
            <div className="col">
              {!this.props.profileData.RemoteRecordingSamples || this.props.profileData.RemoteRecordingSamples.length == 0 &&
                <div className="row"><div className="col">There are no remote recording samples uploaded</div></div>}

                {this.props.profileData.RemoteRecordingSamples && this.props.profileData.RemoteRecordingSamples.map((remoteSample, index) => {
                  let sources = [
                    {src: remoteSample.FileUrl, type: 'audio/mpeg'}
                  ];

                  return <div key={index} className="mb-2">
                    <div className="row">
                      <div className="col">
                        {this.props.profileData.ProfileType == 'Singer' && <i className="ion-icon ion-icon-1x ion-music-note sample-icon"></i>}
                        {this.props.profileData.ProfileType == 'VoiceActor' && <i className="ion-icon ion-icon-1x ion-mic-a sample-icon"></i>}
                        <a href={remoteSample.FileUrl} className="ml-1">{remoteSample.FileName}</a>
                        {this.props.talent === true &&
                          <ProtectedElement permission={permissionToCheck}>
                            <button className="btn" onClick={() => this.removeSample(remoteSample.FileName)} style={{background: "white"}}><i style={{color: "#ff5402"}} className="ion-icon ion-icon-1x ion-android-delete"></i></button>
                          </ProtectedElement>
                        }
                        <br />
                        <span className="ml-3"><small>Added: {remoteSample.CreatedOn}</small></span>
                        <span className="ml-3"><small>Updated: {remoteSample.ModifiedOn}</small></span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <AudioPlayer
                          id={"playerRemote" + index}
                          preload="metadata"
                          width="100%"
                          sources={JSON.stringify(sources)}
                          options={JSON.stringify(config)}
                          tracks={JSON.stringify(tracks)}
                        />
                      </div>
                    </div>
                  </div>
                  })
                }
            </div>
          </div>
          {this.props.talent === true &&
            <div className="col">
              <div className="row">
                <div className="col-md-5">
                  <ProtectedElement permission={permissionToCheck}>
                    <div className="input-group">
                      <input type="file" accept=".mp3,.mp4,.m4a" onChange={this.onFileChange} />
                    </div>
                  </ProtectedElement>
                </div>
              </div>
              <div className="row">
                <div className="col-md-7">
                  <ProtectedElement permission={permissionToCheck}>
                    <button style={{marginTop: "15px"}} className="btn btn-rounded btn-primary" onClick={this.handleAdd}>
                    Add
                    </button>
                  </ProtectedElement>
                </div>
              </div>
            </div>
          }
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  skillVendorId: state.skillVendorPage.overview ? state.skillVendorPage.overview.Id : null
})

const mapDispatchToProps = dispatch => ({
  clearSkillVendorCurrentProfile() { dispatch(clearSkillVendorCurrentProfile()) }
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  WithNotify,
  WithAjax)(RemoteSamplesBox)
